module.exports = __webpack_public_path__ + "img/ehmal.6d8388c0.png";